import { render, staticRenderFns } from "./AppGraficoPizza.vue?vue&type=template&id=a75c2762&"
import script from "./AppGraficoPizza.vue?vue&type=script&lang=js&"
export * from "./AppGraficoPizza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports